import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import FocusTrap from '@/components/common/FocusTrap';


const Overlay = () => (
  <div className="mce-modal-block mce-in"></div>
);

function Modal ({ isOpen, children }) {
  return (isOpen &&
    createPortal(
      <Fragment>
        <Overlay />
        <FocusTrap>
          {children}
        </FocusTrap>
      </Fragment>,
      document.body
    ));
}

Modal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool.isRequired,
};

export default Modal;
